<template>
  <div class="ag-overlay-loading-center" style="position:relative;background-color: transparent;border:none;height: 100%;text-align: center">
    <div style="position:absolute;top:50%;left:0;right:0;transform: translateY(-50%);height: 10%;max-height: 200px">
      <!--      <div style="height: 90%">
        <img :src="overlayBg" style="display: inline-block;height: 100%">
      </div>-->
      <i style="font-style: normal">{{ _i18nGridLocalText('noRowsToShow') }}</i>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import overlayBg from '@/assets/table-individual.png'
export default Vue.extend({
  data() {
    return { overlayBg }
  },
  beforeMount() {},
  mounted() {},
  methods: {}
})
</script>
<style>
.ag-overlay-wrapper {
  display: block!important;
}
</style>
